export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-anchor-7c6e239c8b124a8fd59749d262debd07.svg";